const isNewLineItemCustomPropName = 'IsNewLineItem';

/**
 * Use to add a custom property to the ProductItems in cart model
 * returned from the api so we can fire custom events on re-render
 * @param {Array<object>} oldProductItems - old product items, used to diff and find new items in newProductItems
 * @param {Array<object} newProductItems - new product items that will be modified with custom properties
 * @param {Array<string>} customPropNames - optional | custom properties to add to the new product items
 * @param {Function} extraNewItemCheck - optional | callback function where a product item from newProductItems is
 * 										 passed to allow caller to do additional check if an item is new or not.
 * @returns {Array<object>} newProductItems with added custom properties
 */
function addCustomInfoToProductModel (
	oldProductItems,
	newProductItems,
	customPropNames = [],
	extraNewItemCheck = () => true
) {

	if (!newProductItems || newProductItems.length === 0) {

		return newProductItems;

	}

	const newItemIds = newProductItems
		// Id is retained for broken apart ComboKitSkus so we also have to check for ShortSku
		.filter(
			(newP) => (!oldProductItems.length
					|| !oldProductItems.some((op) => op.Id === newP.Id && op.ShortSku === newP.ShortSku))
				&& extraNewItemCheck(newP)
		)
		.map((p) => p.Id);

	if (!newItemIds.length) {

		return newProductItems;

	}

	return newProductItems.map((p) => {

		const newProdId = p.Id;
		// if this item is in the list of newItemIds, assign all properties to it as true
		const ifCurrentIsNewItem = newItemIds.includes(newProdId);

		if (!ifCurrentIsNewItem) {

			return p;

		}

		[ isNewLineItemCustomPropName, ...customPropNames ].forEach((prop) => {

			// eslint-disable-next-line no-param-reassign
			p[prop] = true;

		});

		return p;

	});

}

export default addCustomInfoToProductModel;
